.installmentRow {
  display: flex;
  min-height: var(--pgm-sys-spacing-16);
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  background: transparent;
  color: var(--pgm-sys-color-on-surface);
}

.billetButton {
  --pgm-icon-button-shape-full: var(--pgm-sys-spacing-3);
  --md-outlined-icon-button-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-focus-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-outline-color: var(--pgm-sys-color-outline-variant);
  --md-outlined-icon-button-pressed-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-outlined-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-surface-variant);
  flex: 0 0 auto;
}

.installmentNumber {
  min-width: var(--pgm-sys-spacing-8);
  color: var(--pgm-sys-color-on-surface);
}

.installmentInformation {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--pgm-sys-spacing-4);
}

.tag {
  display: inline-flex;
  box-sizing: content-box;
  min-height: var(--pgm-sys-spacing-4);
  padding: 2px;
  align-items: center;
  gap: var(--pgm-sys-spacing-1);
  border-radius: var(--pgm-sys-spacing-1);
}

.tagIcon {
  width: var(--pgm-sys-spacing-3);
  height: var(--pgm-sys-spacing-3);
  font-size: var(--pgm-sys-spacing-3);
  line-height: var(--pgm-sys-spacing-3);
}

.filledTagIcon {
  font-variation-settings: "FILL" 1;
}

.statusPaid {
  background: var(--pgm-sys-color-surface-container);
  color: var(--pgm-sys-color-on-surface-variant);
}

.generatedBillet {
  background: var(--pgm-sys-color-surface-container-highest);
  color: var(--pgm-sys-color-on-surface);
}

.statusOverdue {
  background: var(--pgm-sys-color-error);
  color: var(--pgm-sys-color-on-error);
}

.statusError {
  background: var(--pgm-sys-color-error-container);
  color: var(--pgm-sys-color-on-error-container);
}

.statusOpen {
  background: var(--pgm-sys-color-info-container);
  color: var(--pgm-sys-color-on-info-container);
}

.installmentSelection {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: var(--pgm-sys-spacing-2);
}

.installmentSelectionWithoutCheckbox {
  padding-right: var(--pgm-sys-spacing-4);
}

.installmentValue {
  color: var(--pgm-sys-color-on-surface-variant);
  white-space: nowrap;
}

.checkboxControl {
  display: inline-flex;
  flex: 0 0 var(--pgm-sys-spacing-10);
  align-items: center;
  justify-content: center;
  width: var(--pgm-sys-spacing-10);
  height: var(--pgm-sys-spacing-10);
  margin: var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-0) var(--pgm-sys-spacing-0);
  cursor: pointer;
}

.checkboxControl input {
  position: relative;
  width: var(--pgm-sys-spacing-4);
  height: var(--pgm-sys-spacing-4);
  margin: var(--pgm-sys-spacing-0);
  appearance: none;
  border: 2px solid var(--pgm-sys-color-on-surface-variant);
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
}

.checkboxControl input:checked {
  border-color: var(--pgm-sys-color-primary);
  background: var(--pgm-sys-color-primary);
}

.checkboxControl input:checked::after {
  position: absolute;
  top: 0;
  left: var(--pgm-sys-spacing-1);
  width: var(--pgm-sys-spacing-1);
  height: var(--pgm-sys-spacing-2);
  border: solid var(--pgm-sys-color-on-primary);
  border-width: 0 2px 2px 0;
  content: "";
  transform: rotate(45deg);
}

.checkboxControl input:focus-visible {
  outline: 2px solid var(--pgm-sys-color-secondary);
  outline-offset: 2px;
}

.checkboxControlDisabled,
.checkboxControl input:disabled {
  cursor: default;
}

.checkboxControl input:disabled {
  opacity: 0.38;
}

@media (max-width: 768px) {
  .installmentRow {
    min-height: auto;
    padding-block: var(--pgm-sys-spacing-2);
    flex-wrap: wrap;
  }

  .installmentInformation {
    min-width: calc(100% - 88px);
  }

  .installmentSelection {
    width: 100%;
    padding-left: var(--pgm-sys-spacing-10);
    justify-content: flex-end;
  }
}
